<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p class="copyt">Publisher: Amy Marson</p>
<p class="copyt">Creative Director: Gailen Runge</p>
<p class="copyt">Editor: Lynn Koolish</p>
<p class="copyt">Technical Editors: Alison M. Schmidt and Gailen Runge</p>
<p class="copyt">Cover/Book Designer: Page + Pixel</p>
<p class="copyt">Production Coordinator: Zinnia Heinzmann</p>
<p class="copyt">Production Editors: Jennifer Warren, Nicole Rolandelli, and Jeanie German</p>
<p class="copyt">Illustrator: Lon Eric Craven</p>
<p class="copyt">Photo Assistants: Carly Jean Marin and Mai Yong Vang</p>
<p class="copyt">Style photography by Lucy Glover and instructional photography by Diane Pedersen and Amanda Jean Nyberg, unless otherwise noted</p>
<p class="copyt">Published by Stash Books, an imprint of C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?6b30a259